<h2 mat-dialog-title>Journal Entry Receipt</h2>

<mat-dialog-content>
    <mat-progress-bar *ngIf="!isLoaded" mode="indeterminate"></mat-progress-bar>
    <form name="jeReceiptDialogForm">
        <div ngModelGroup="pnl_jeReceipt">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>Cash Transactions</mat-card-title>
                </mat-card-header>

                <mat-card-content fxLayoutAlign="space-around center">
                    <metadata-panel fxFlex [metadata]="journalEntryCashTransactionsMetadata" [model]="metadataModel">
                    </metadata-panel>
                </mat-card-content>
            </mat-card>

            <mat-card appearance="outlined" *ngIf="isLoaded">
                <mat-card-header>
                    <mat-card-title>Receipt Transaction</mat-card-title>
                </mat-card-header>

                <mat-card-content fxLayoutAlign="space-around center">
                    <metadata-panel fxFlex [metadata]="journalEntryReceiptMetadata" [model]="metadataModel">
                    </metadata-panel>
                </mat-card-content>
            </mat-card>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="mt10">
    <command-bar [commands]="commands" telemetry="Menu-JournalEntryReceipt">
    </command-bar>
</mat-dialog-actions>
